export default __webpack_public_path__ + "static/palettte3-00f9ef60cb7eff3a2b5847ac42a1d946.jpg";